import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../../core/redux/action";
import { ChevronDown, ChevronUp, Info } from "react-feather";
import { all_routes } from "../../../Router/all_routes";
import { useEffect } from "react";
import apiHandler from "../../common/api";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";

function Appconfig() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const userData = useSelector((state) => state.user_data);
  const navigate = useNavigate();
  const routes = all_routes;

  console.log(userData, "userData");

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [formData, setFormData] = useState({
    hour24Notification: 0,
    hour12Notification: 0,
    hour1Notification: 0,
    feedbackRequestNotification: 0,
    birthdayNotification: 0,
    dailyBusinessSummaryNotification: 0,
  });

   const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getCustomerDetails = async () => {
      const response = await apiHandler({
        method: "GET",
        route: `Superadmin/appconfig`,
      });
      if (response.ResponseCode === "SUCCESS") {
        setFormData(response.ResponseData);
      }
    };
    getCustomerDetails();
  }, []);

  console.log(formData, "formData");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const response = await apiHandler({
      method: "POST",
      route: `Superadmin/appconfigupsert`,
      payload: formData,
    });
    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
        navigate(routes.dashboard);
    } else {
      setLoading(false);
      console.log(response, "data");
    }
  };

  const handleCancle = () => {
    navigate(routes.dashboard);
  };

  return (
    <>
    <LoadingSpinner isLoading={loading} />
    <div>
      {" "}
      <div className="mt-5">
        <div className="page-wrapper  pt-0">
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>App Config</h4>
                  <h6>Manage App Config</h6>
                </div>
              </div>

              <ul className="table-top-head">
                <li>
                  <OverlayTrigger
                    placement="top"
                    overlay={renderCollapseTooltip}
                  >
                    <Link
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      id="collapse-header"
                      className={data ? "active" : ""}
                      onClick={() => {
                        dispatch(setToogleHeader(!data));
                      }}
                    >
                      <ChevronUp />
                    </Link>
                  </OverlayTrigger>
                </li>
              </ul>
            </div>

            <div className="card">
              <div className="card-body add-product pb-0">
                <div
                  className="accordion-card-one accordion"
                  id="accordionExample"
                >
                  <div className="accordion-item show">
                    <div className="accordion-header" id="headingOne">
                      <div
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <div className="addproduct-icon">
                          <h5>
                            <Info className="add-info" />
                            <span>Notification Setting</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="row mb-3">
                          <div className="d-flex align-items-center form-group col-xl-6 col-md-6 col-12 gap-2">
                            <label className="text-sm-medium">
                              Enable 24 Hour Notification
                            </label>
                            <input
                              className="custome-boder form-check-input"
                              type="checkbox"
                              name="hour24Notification"
                              checked={formData.hour24Notification === 1}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  hour24Notification: e.target.checked ? 1 : 0,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="d-flex align-items-center form-group col-xl-6 col-md-6 col-12 gap-2">
                            <label className="text-sm-medium">
                              Enable 12 Hour Notification
                            </label>
                            <input
                              className="custome-boder form-check-input"
                              type="checkbox"
                              name="hour12Notification"
                              checked={formData.hour12Notification === 1}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  hour12Notification: e.target.checked ? 1 : 0,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="d-flex align-items-center form-group col-xl-6 col-md-6 col-12 gap-2">
                            <label className="text-sm-medium">
                              Enable 1 Hour Notification
                            </label>
                            <input
                              className="custome-boder form-check-input"
                              type="checkbox"
                              name="hour1Notification"
                              checked={formData.hour1Notification === 1}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  hour1Notification: e.target.checked ? 1 : 0,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="d-flex align-items-center form-group col-xl-6 col-md-6 col-12 gap-2">
                            <label className="text-sm-medium">
                              Enable Feedback Request Notification
                            </label>
                            <input
                              className="custome-boder form-check-input"
                              type="checkbox"
                              name="feedbackRequestNotification"
                              checked={
                                formData.feedbackRequestNotification === 1
                              }
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  feedbackRequestNotification: e.target.checked
                                    ? 1
                                    : 0,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="d-flex align-items-center form-group col-xl-6 col-md-6 col-12 gap-2">
                            <label className="text-sm-medium">
                              Enable Birthday Notification
                            </label>
                            <input
                              className="custome-boder form-check-input"
                              type="checkbox"
                              name="birthdayNotification"
                              checked={formData.birthdayNotification === 1}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  birthdayNotification: e.target.checked
                                    ? 1
                                    : 0,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="d-flex align-items-center form-group col-xl-6 col-md-6 col-12 gap-2">
                            <label className="text-sm-medium">
                              Enable Daily Business Summary Notification
                            </label>
                            <input
                              className="custome-boder form-check-input"
                              type="checkbox"
                              name="dailyBusinessSummaryNotification"
                              checked={
                                formData.dailyBusinessSummaryNotification === 1
                              }
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  dailyBusinessSummaryNotification: e.target
                                    .checked
                                    ? 1
                                    : 0,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 col-12 mt-4">
                  <div className="btn-addproduct mb-4">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-md me-2"
                      onClick={handleCancle}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-primary btn-md me-2"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Appconfig;
